import { render, staticRenderFns } from "./design.vue?vue&type=template&id=547dd5ab&scoped=true&"
import script from "./design.vue?vue&type=script&lang=js&"
export * from "./design.vue?vue&type=script&lang=js&"
import style0 from "./design.vue?vue&type=style&index=0&id=547dd5ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547dd5ab",
  null
  
)

component.options.__file = "design.vue"
export default component.exports